import BaseReportController from '../baseReportController';
import { filter as _filter } from 'lodash';

class ModelEnquiryController extends BaseReportController {
  constructor(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, $q, lookupService, utilsService) {
    "ngInject";

    super(reportingService, loadingService, utilsService);

    if(!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) { return; }

    this.authService = authService;
    this.reportingService = reportingService;
    this.userService = userService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.$scope = $scope;
    this.printService = printService;
    this.exportService = exportService;
    this.$q = $q;
    this.lookupService = lookupService;
    this.utilsService = utilsService;

    this.reportCriteria = {};
    this.dtPopups = {};
    this.errMsgs = [];
    
    this.panels = {
      reportCriteria: true,
      reportSummary: false,
      reportData: false
    };

    this.summary = [];

    this.initializeLookups()
    .then(() => {
      this.getVehicleConditionList();
      this.getEnquiryStatusList();
      this.getUserLocations();
      this.getDateRangeList();
      this.getEnquiryContactList();
      this.getDateRangeTypeList();
      this.reset();
    });
  }

  initializeLookups() {
    const ctrl = this;
    const deferred = ctrl.$q.defer();

    this.lookupService.lookupBrands()
      .then(brands => {
        brands.splice(0, 1);
        brands.unshift({id: null, name: 'All'});
        this.brands = brands;

        deferred.resolve();
      });

      return deferred.promise;
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  getVehicleConditionList() {
    this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
    this.vehicleConditionList.unshift({id:null, name: 'All'});
  }

  getEnquiryStatusList() {
    this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
    this.enquiryStatusList.unshift({id:null, name: 'All'});
  }

  getDateRangeList() {
    this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
  }
  
  getEnquiryContactList() {
    this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
    this.enquiryContactList.unshift({id:null, name: 'All'});
  }

  getDateRangeTypeList() {
    this.dateRangeTypeList = [];
    this.dateRangeTypeList.push({id:'createddate', name: 'Created Date'});
    this.dateRangeTypeList.push({id:'confirmeddate', name: 'Confirmed Date'});
    this.dateRangeTypeList.push({id:'deliverydate', name: 'Delivery Date'});
  }

  showDatePopup(fieldName) {
    this.dtPopups[fieldName] = true;
  }

  reset() {    
    this.$scope.$broadcast('reports:reset');
    
    this.summary = [];

    this.errMsgs = [];

    this.reportCriteria.dateRangeOption = this.dateRangeList[0];
    this.reportCriteria.startDate = new Date();
    this.reportCriteria.endDate = new Date();
    this.reportCriteria.location = this.userLocations[0];
    this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
    this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
    this.reportCriteria.brand = this.brands[0];
    this.reportCriteria.enquiryContact = this.enquiryContactList[2];
    this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];

    this.updateUserList();
  }

  updateUserList() {
    this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');

    this.userService.getEntityUsers(this.getLocationIds())
      .then((response) => {
        this.userList = response.data.map((i) => {return {id: i.userId, name: i.firstName + ' ' + i.lastName};});
        this.userList.unshift({id: null, name: 'All'});

        this.reportCriteria.user = this.userList[0];
      })
      .finally(() => {
        this.loadingService.hideLoading('reportCriteria');
      });
  }

  runReport() {
    this.panels.reportData = true;
    
    if (!this.validateCriteria()) {return;}

    this.loadingService.showLoading('reportData', 'Running Report ...');

    this.reportingService.runReport('modelEnquiry', this.parseCriteria())
      .then(response => {
        this.reportData = response.data;
      })
      .finally(() => {
        this.loadingService.hideLoading('reportData');
      });
  }

  onReportRun(summary){
    this.summary = summary;
  }

  validateCriteria() {
    this.errMsgs = [];

    if (!this.reportCriteria.startDate) {
      this.errMsgs.push('Please provide a Start Date');
    }

    if (!this.reportCriteria.endDate) {
      this.errMsgs.push('Please provide an End Date');
    }

    if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
      this.errMsgs.push('Start Date can not be greater than End Date');
    }

    return this.errMsgs.length === 0;
  }

  parseCriteria() {
    let parsedCriteria = {};

    this.parseStartAndEndDate(parsedCriteria);
    
    parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
    parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
    parsedCriteria.locationIds = this.getLocationIds();
    parsedCriteria.salesRepId = this.reportCriteria.user.id;
    parsedCriteria.brandId = this.reportCriteria.brand.brandId;
    parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
    parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;

    return parsedCriteria;
  }

  getLocationIds() {
    let locationIds;

    if (!this.reportCriteria.location.id) {
      locationIds = _filter(this.userLocations, o => o.id).map(ul => ul.id);
    }
    else {
      locationIds = [this.reportCriteria.location.id];
    }

    return locationIds;
  }
  
  printReport(){
    if (!this.validateCriteria()) {
      return;
    }

    this.printService.printReport('Model Enquiry', this.parseCriteria());
  }

  exportReport(){
    if (!this.validateCriteria()) {
      return;
    }

    this.exportService.exportReport('Model Enquiry', this.parseCriteria());
  }  
}

export default ModelEnquiryController;



// WEBPACK FOOTER //
// ./client/app/components/reports/modelEnquiry/modelEnquiry.controller.js